module.exports = __webpack_public_path__ + "img/mini-008.b5e19ae6.jpg";